export class CancellationPolicy {
  primaryPolicy: string;
  secondaryPolicies: Array<string> = [];

  constructor (cancellationPolicy: string, secondaryCancellationPolicies: Array<string>) {
    this.primaryPolicy = cancellationPolicy;
    this.secondaryPolicies = secondaryCancellationPolicies;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/cancellation-policy.model.ts